module.exports = function() {
	return new Worker(__webpack_public_path__ + "a3fb706891f5483e9044.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./scripts/workers/sway.worker.js
// module id = 383
// module chunks = 0